
let popupTpl = _.template(
    `<div class="Dialog" style="max-width: 400px; pointer-event:none;">
        <div class="Dialog_head"><%= title %></div>
        <div class="Dialog_content">
            <div class="Dialog_num">Квартира № <%= num %></div>
            <dl class="Dialog_dl">
                <dt class="Dialog_dt">Корпус:</dt>
                <dd class="Dialog_dd"><%= house %></dd>
                <dt class="Dialog_dt">Этаж:</dt>
                <dd class="Dialog_dd"><%= floor %></dd>
                <dt class="Dialog_dt">Общая площадь:</dt>
                <dd class="Dialog_dd"><%= area %> м<sup>2</sup></dd>
                <dt class="Dialog_dt">Стоимость:</dt>
                <dd class="Dialog_dd"><%= price.toLocaleString("Ru-ru") %>&nbsp;₽</dd>
            </dl>
        </div>
    </div>`.replace(/\s{2,}/g, "")
);

let windowViewTpl = _.template(
    `<span class="FotoBtn_toolp _svg">Вид из окна</span>`.replace(/\s{2,}/g, "")
);

let setupSectionHoverBehaviour = () => {
    $(".BldScheme_link").hover(
        event => {
            let $item = $(event.currentTarget);
            $item.addClass("BldScheme_link-active");
        },
        event => {
            let $item = $(event.currentTarget);
            $item.removeClass("BldScheme_link-active");
        }
    );

    let $scheme = $(".BldScheme");

    if ($scheme.length) {
        $scheme.tooltip({
            items: "[data-params]",
            track: true,
            hide: { duration: 0 },
            show: { duration: 0 },
            content: function() {
                let $el = $(this);
                let params = $el.data("params");
                let dataToRender = {
                    title: null,
                    num: null,
                    price: null,
                    house: null,
                    floor: null,
                    area: null
                };
                _.assignIn(dataToRender, params);
                return popupTpl(dataToRender);
            }
        });

        /*$scheme.tooltip({
            items: "[data-params]",
            track: true,
            hide: { duration: 0 },
            show: { duration: 0 },
            content: function() {
                return 'Текст';
            }
        });*/
    }
};

let toolpWindowView = () => {
    let $targetToolp = $("#eye");

    if ($targetToolp.length) {
        $targetToolp.tooltip({
            items: "[data-svg-toolp]",
            classes: {
                "ui-tooltip": "WindowViewToolp"
            },
            //position: { my: "center bottom+23", at: "center bottom+23" },
            track: false,
            hide: { duration: 300 },
            show: { duration: 300 },
            content: function() {
                return windowViewTpl();
            }
        });
    }
};

$(window).on("load", () => {
    setupSectionHoverBehaviour();
    toolpWindowView();
});


$('.SelectFloor').selectmenu({
    classes: {
        "ui-selectmenu-menu": "SelectFloor",
        "ui-selectmenu-text": "SelectFloor_text",
        "ui-selectmenu-button": "SelectFloor_btn"
    },
    change: function( event, ui ) {
        console.log('ui.item.value', ui.item.value)
        let ref = ui.item.value;
        let $schemeBlock = $(".HouseSection_schemeScroll");
        $schemeBlock.addClass("HouseSection_inner-disabled");
        $(".floor-selector").val( $(event.currentTarget).attr("floor_num") );
        $.ajax({
            url: ref + "?hide_areas=y",  
            dataType: "html"
        })
            .done(response => {
                let $newDoc = $(response);

                let $newSectionInfo = $newDoc.find(".HouseSection_schemeScroll");
                $schemeBlock.html($newSectionInfo.html());
                $("#filterForm").submit();
                setupSectionHoverBehaviour();

                let title = $newDoc.filter("title").html();
                document.title = title;
                history.replaceState({}, title, ref);
            })
            .fail(function() {
                alert("Не удалось получить данные о секции!/nПопробуйте позже.");
            })
            .always(function() {
                $schemeBlock.removeClass("HouseSection_inner-disabled");
            });
    }
});

$("main").on("click", ".HouseSectionNav_switch", event => {
    event.preventDefault();
    let currentLink = event.currentTarget;
    let ref = event.currentTarget.href;
    $("#floor_from, #floor_to").val($(this).attr("floor_num")); 
    $('.HouseSectionNav_link').removeClass('HouseSectionNav_link-active');
    currentLink.className += ' HouseSectionNav_link-active';
    let $schemeBlock = $(".HouseSection_schemeScroll");
    $schemeBlock.addClass("HouseSection_inner-disabled");
    $.ajax({
        url: ref,
        dataType: "html"
    })
        .done(response => {
            let $newDoc = $(response);

            let $newSectionInfo = $newDoc.find(".HouseSection_schemeScroll");
            $schemeBlock.html($newSectionInfo.html());
            $("#filterForm").submit();
            setupSectionHoverBehaviour();

            let title = $newDoc.filter("title").html();
            document.title = title;
            history.replaceState({}, title, ref);
        })
        .fail(function() {
            alert("Не удалось получить данные о секции!/nПопробуйте позже.");
        })
        .always(function() {
            $schemeBlock.removeClass("HouseSection_inner-disabled");
        });
});

{
    let activeHouse = $('.HousesNav_item-active').data('name');
    //$('.HousesScheme_svg').find('[data-name="'+ activeHouse +'"]').addClass('HousesScheme_polygonActive');
}

let FlatWindowView = $('[data-flat-view]');
$(FlatWindowView).fancybox({
    loop: false,
    autoSize: true,
    clickContent: false,
    closeBtn: false,
    smallBtn: true,
    margin: [0, 0, 0, 0],
    padding:    [0, 0, 0, 0],
    btnTpl: {
        smallBtn:
            '<button data-fancybox-close class="fancybox-button fancybox-button--close FlatWindowView_close" title="0000">' +
            '<svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
            '    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
            '        <g id="1.1-Открытое-меню" transform="translate(-1388.000000, -33.000000)" fill="#251914">\n' +
            '            <g id="Group-2" transform="translate(0.000000, -1.000000)">\n' +
            '                <g id="Меню" transform="translate(858.000000, 0.000000)">\n' +
            '                    <g id="Group-3" transform="translate(497.000000, 1.000000)">\n' +
            '                        <path d="M41.563362,41.563362 L41.563362,31 L43.5439915,31 L43.5439915,41.563362 L54.1073536,41.563362 L54.1073536,43.5439915 L43.5439915,43.5439915 L43.5439915,54.1073536 L41.563362,54.1073536 L41.563362,43.5439915 L31,43.5439915 L31,41.563362 L41.563362,41.563362 Z" id="Rectangle-16-Copy" transform="translate(42.553677, 42.553677) rotate(45.000000) translate(-42.553677, -42.553677) "></path>\n' +
            '                    </g>\n' +
            '                </g>\n' +
            '            </g>\n' +
            '        </g>\n' +
            '    </g>\n' +
            '</svg>' +
            "</button>",
    },
    parentEl: '.FlatWindowView',
    afterClose: function() {
        $('[data-svg-toolp]').tooltip("disable");
    }
});
